module.exports = __webpack_public_path__ + "img/hhp.2106c1ff.svg";